import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';
import {
  ICharge,
  IChargeForSelect,
  ICreditForSelect,
  IDataEditAging,
  IDataEditBillingSchedule,
  IResponCharges,
  IScheduleAndEvent
} from '../interfaces/billing.interface';
import { map } from 'rxjs/operators';
import { constant } from '../../app.constants';
import { IDataBillingExport } from '../interfaces/billing-form.interface';
import { Response } from '@angular/http';

@Injectable()
export class BillingEditService extends ParentService {

  constructor(private http: Http) {
    super();
  }

  getChagesForSelect(tripid: number): Observable<IChargeForSelect[]> {
    return this.http.get(`${constant.URL_CHARGES_FOR_SELECT}${tripid}`, this.getHeader()).pipe(
      map((response: any) => response.json() as IChargeForSelect[])
    );
  }

  createTripCharge(tripCharge: ICharge) {
    return this.http.post(`${constant.URL_BILLING.TRIP_CHARGE.BASE}`, tripCharge, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      )
      .catch(error => Observable.throw(error.json()));
  }

  updateTripCharge(tripCharge: ICharge) {
    const body = JSON.stringify(tripCharge);
    return this.http.put(`${constant.URL_BILLING.TRIP_CHARGE.BASE}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }

  createTripCredit(tripCredit) {
    const body = JSON.stringify(tripCredit);
    return this.http.post(`${constant.URL_BILLING.TRIP_CREDITS.BASE}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }
  updateTripCredit(tripCredit) {
    const body = JSON.stringify(tripCredit);
    return this.http.put(`${constant.URL_BILLING.TRIP_CREDITS.BASE}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }

  getChagesByTrip(tripid: number, inactive: boolean): Observable<IResponCharges> {
    return this.http.get(`${constant.URL_BILLING.TRIP_CHARGE.BASE}/${tripid}?showInactive=${inactive}`, this.getHeader()).pipe(
      map((response: any) => response.json() as IResponCharges)
    );
  }

  getCreditForSelect(): Observable<ICreditForSelect[]> {
    return this.http.get(`${constant.URL_CREDIT}`, this.getHeader()).pipe(
      map((response: any) => response.json() as ICreditForSelect[] )
    );
  }

  getCreditsByTrip(tripid: number, inactive: boolean) {
    return this.http.get(`${constant.URL_BILLING.TRIP_CREDITS.BASE}/${tripid}?showInactive=${inactive}`, this.getHeader()).pipe(
      map((response: any) => response.json())
    );
  }

  recalculateCharges(tripsid: number[]) {
    return this.http
      .put(constant.URL_RECALC_EXPORT, tripsid, this.headerPost())
      .map((res: any) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteCharge(chargeId: number) {
    return this.http.delete(`${constant.URL_BILLING.TRIP_CHARGE.BASE}/${chargeId}`, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }

  deleteCredit(creditId: number) {
    return this.http.delete(`${constant.URL_BILLING.TRIP_CREDITS.BASE}/${creditId}`, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }
  getPayorsTrip(riderId: number) {
    return this.http.get(`${constant.URL_RIDER_PAYOR_DETAIL}/${riderId}`, this.getHeader()).pipe(
      map((response: any) => response.json())
    );
  }
 // TripCharge/{tripId}?showInactive=true  para las grillas  URL_RIDER_PAYOR_DETAIL
  /**
   * @descriptionrae los trips segun el form
   */
  getTripsToExportBilling(data: IDataBillingExport) {
    const body = JSON.stringify(data);
    return this.http.post(`${constant.URL_TRIPS_TO_EXPORT_BILLING}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @descriptionrae genera formas de trips
   */
  generateFormOfTrips(body: any) {
    return this.http.post(`${constant.URL_FORM_OF_TRIPS}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @name getBillingSchedule
   * @description
   */
  public getBillingScheduleDetails(): Observable<IScheduleAndEvent[]> {
    return this.http
      .get(constant.URL_BILLING_SCHEDULE_LIST, this.getHeader())
      .map(res => res.json());
  }
  /**
   * @descriptionrae los trips segun el form
   */
  public editBillingSchedule(data: IDataEditBillingSchedule): Observable<any> {
    const body = JSON.stringify(data);
    return this.http.put(`${constant.URL_BILLING_SCHEDULE_EDIT}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @descriptionrae actualiza EL aging
   */
  public editAging(data: IDataEditAging) {
    const body = JSON.stringify(data);
    return this.http.put(`${constant.URL_BILLING_SCHEDULE_UPDATE_AGING}`, body, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }

  getTripDuplicate(tripid: number) {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.IS_DUPLICATE_TRIP}/${tripid}`;
    return this.http
      .get(url, this.getHeader())
      .pipe(map((response: any) => response.json()));
  }

  postTripDuplicate(tripid: number) {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.IS_DUPLICATE_TRIP}/${tripid}`;
    return this.http
      .post(url, tripid, this.headerPost())
      .map((res: Response) => res)
      .catch((error: any) => {
        return Observable.throw(error.json());
      });
  }

  deleteTripDuplicate(tripid: number) {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.IS_DUPLICATE_TRIP}/${tripid}`;
    return this.http
      .delete(url, this.headerPost())
      .map((res: Response) => res)
      .catch((error: any) => {
        return Observable.throw(error.json());
      });
  }
  getTripsSummaryBillingClaim(data: {start: string, end: string, payorsIds: number[]}) {
    return this.http.post(`${constant.URL_BILLING_CLAIM_TRIPS_SUMMARY}`, data, this.headerPost()).pipe(
      map((response: any) => response.json())
    ).catch((error: any) => Observable.throw(error.json()));
  }

  getTripNonNegotiable(tripid: number): Observable<any> {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.NON_NEGOTIABLE_TRIP}/${tripid}`;
    return this.http
      .get(url, this.getHeader())
      .pipe(map((response: any) => response.json()));
  }

  postTripNonNegotiable(tripid: number): Observable<any> {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.NON_NEGOTIABLE_TRIP}/${tripid}`;
    return this.http.post(url, tripid, this.headerPost())
      .map((res: Response) => res)
      .catch((error: any) => {
        return Observable.throw(error.json());
      });
  }

  deleteTripNonNegotiable(tripid: number): Observable<any> {
    const url = `${constant.URL_BILLING.TRIP_CHARGE.NON_NEGOTIABLE_TRIP}/${tripid}`;
    return this.http.delete(url, this.headerPost())
      .map((res: Response) => res)
      .catch((error: any) => {
        return Observable.throw(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/billing-edit.service.ts